<template>
  <div>
    <el-row>
      <el-col :span="24">
        <banner :homePageInfo="homePageInfo" :userInfo="userInfo" @jumpToProductPage="handleJumpToProductPage"/>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="content">
          <div class="nb">
            <product-list 
              :prodClasses="homePageInfo.prodClasses" 
              @jumpToProductPage="handleJumpToProductPage"
              @jumpToProductDetail="handleJumpToProductDetail"/>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Banner from '@/components/platform/homePage/Banner'
import ProductList from '@/components/platform/homePage/ProductList'
import { getHomePageData, getUserInfo, saveAccessLog } from '@/api/platform/homePageApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'HomePage',
  components: {
    Banner,
    ProductList
  },
  data() {
    return {
      homePageInfo: {
        informations: [],
        prodClasses: []
      },
      userInfo: {
        storeTypeCd: "",
        name: "",
        tel: "",
        levelCd: "",
        userId: "",
        cartProducts: []
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.loadData()
    this.checkUserInfo()
  },
  mounted() {
    this.initScrollEvent()
  },
  methods: {
    async loadData() {
      try {
        const res = await getHomePageData({
          page: 1,
          row: 100
        })
        this.homePageInfo.informations = res.data.platformInformation
        this.homePageInfo.prodClasses = res.data.platformProductClass
      } catch (error) {
        console.error('Failed to load home page data:', error)
      }
    },
    async checkUserInfo() {
      try {
        const user = await getUserInfo()
        if (user) {
          this.userInfo = user
          if (user.watermark === 'true') {
            this.$watermark({
              watermark_txt: this.$t('systemName') + ":" + user.name
            })
          }
        }
      } catch (error) {
        console.error('Failed to get user info:', error)
      }
    },
    handleJumpToProductPage(hktId) {
      this.$router.push(`/pages/platform/product?hktId=${hktId}`)
    },
    handleJumpToProductDetail(productId) {
      this.$router.push(`/pages/platform/productDetail?productId=${productId}`)
    },
    initScrollEvent() {
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.setLeftBarPosition)
    },
    handleScroll() {
      // Implement scroll logic here
    },
    setLeftBarPosition() {
      // Implement responsive layout logic here
    },
    async logAccess() {
      try {
        const params = {
          accessUrl: window.location.href,
          loginState: this.userInfo.userId ? '1' : '0'
        }
        if (this.userInfo.userId) {
          params.loginName = this.userInfo.name
          params.loginId = this.userInfo.userId
        }
        await saveAccessLog(params)
      } catch (error) {
        console.error('Failed to save access log:', error)
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.setLeftBarPosition)
  }
}
</script>

<style scoped>
.banner {
  width: 100%;
}

.content {
  width: 100%;
}

.nb {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
</style>